if (!customElements.get('store-video-player')) {
  class StoreVideoPlayer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      try {
        this.videos = JSON.parse(this.querySelector('[data-store-videos]').textContent);
      } catch {
        return;
      }
      if (!this.video || !Array.isArray(this.videos) || !this.videos.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.locations = Array.from(this.querySelectorAll('[data-video-index]'));
      this.headingElement = this.querySelector('[data-video-title]');
      this.link = this.querySelector('[data-video-link]');
      this.status = this.querySelector('[data-video-status]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQuery.addEventListener('change', () => {
        if (!this.mobileQuery.matches) this.video.pause();
      }, options);
      this.video.loop = this.videos.length === 1;
      this.generation = 0;
      this.locations.forEach((location) => {
        location.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          this.select(Number(location.getAttribute('data-video-index')), !this.video.paused);
        }, options);
      });
      this.video.addEventListener('error', () => {
        this.status.hidden = false;
      }, options);
      this.video.addEventListener('playing', () => {
        this.status.hidden = true;
      }, options);
      this.video.addEventListener('ended', () => {
        if (this.mobileQuery.matches && !document.hidden && this.videos.length > 1) {
          this.select((this.index + 1) % this.videos.length, true);
        }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
      }, options);
      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.videos.findIndex((video) => video.block_id === event.detail?.blockId);
          if (index >= 0) this.select(index, false);
        }, options);
      }
      this.select(this.index ?? 0, false);
    }

    select(index, resume) {
      const item = this.videos[index];
      if (!Number.isInteger(index) || !item) return;
      const mobile = this.mobileQuery.matches;
      const src = (mobile && item.mobile_src) || item.src || item.mobile_src;
      if (!src) return;
      const poster = (mobile && item.mobile_poster) || item.poster || item.mobile_poster || '';
      const nextSrc = new URL(src, document.baseURI).href;
      const currentSrc = this.video.getAttribute('src');
      const changed = !currentSrc || new URL(currentSrc, document.baseURI).href !== nextSrc;
      const generation = ++this.generation;
      this.index = index;
      this.status.hidden = true;
      this.headingElement.textContent = item.title;
      this.link.textContent = item.button || '';
      this.link.hidden = !item.link || !item.button;
      if (item.link) this.link.setAttribute('href', item.link);
      if (item.external) {
        this.link.setAttribute('target', '_blank');
        this.link.setAttribute('rel', 'noopener noreferrer');
      } else {
        this.link.removeAttribute('target');
        this.link.removeAttribute('rel');
      }
      this.video.setAttribute('aria-label', item.label || item.title);
      this.locations.forEach((location, i) => location.setAttribute('aria-current', String(i === index)));
      if (changed) this.video.pause();
      if (poster) this.video.setAttribute('poster', poster);
      else this.video.removeAttribute('poster');
      if (changed) {
        this.video.setAttribute('src', src);
        this.video.load();
      }
      if (resume) {
        if (!changed && this.video.ended) this.video.currentTime = 0;
        const result = this.video.play();
        result?.catch((error) => {
          if (generation === this.generation && error.name !== 'AbortError') this.status.hidden = false;
        });
      }
    }

    disconnectedCallback() {
      this.generation++;
      this.controller?.abort();
      this.controller = null;
      this.video?.pause();
    }
  }
  customElements.define('store-video-player', StoreVideoPlayer);
}
